import { ISaveSearchProps } from '@cian/save-search-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { trackSubscribed } from './tracking';
import { getJsonQuery } from './utils';
import { ISaveSearchModalProps, SaveSearchModal } from '../../components/SaveSearchModal';
import { selectUser } from '../../selectors/offerData';
import { IState } from '../../store';
import { useApplicationContext } from '../ApplicationContext';

export type TSaveSearchModalContainerProps = Pick<ISaveSearchModalProps, 'open' | 'onClose'>;

export const SaveSearchModalContainer: React.FC<TSaveSearchModalContainerProps> = sharedProps => {
  const { httpApi, logger } = useApplicationContext();
  const subdomain = useSelector<IState, string>(state => state.pageData.subdomain);
  const offer = useSelector<IState, IOfferSchema>(state => state.offerData.offer);
  const user = useSelector(selectUser);
  const jsonQuery = React.useMemo(() => getJsonQuery(offer), [offer]);
  const defaultTitle = React.useMemo(() => offer.geo.address.map(a => a.shortName).join(', '), [offer.geo.address]);

  const handleOnSubscribed = React.useCallback(
    (parameters: Parameters<Required<ISaveSearchProps>['onSubscribed']>[0]) => {
      trackSubscribed({ frequency: parameters.frequency, subscribeToNews: parameters.subscribeToNews });

      if (window.__reloadHeader__) {
        window.__reloadHeader__();
      }
    },
    [],
  );

  return (
    <SaveSearchModal
      {...sharedProps}
      httpApi={httpApi}
      logger={logger}
      subdomain={subdomain}
      jsonQuery={jsonQuery}
      defaultTitle={defaultTitle}
      userEmail={user?.isAuthenticated ? user.email : null}
      hideLicense={!!user?.isAuthenticated}
      onSubscribed={handleOnSubscribed}
    />
  );
};
